import { useSelector } from "react-redux";

const useGetApplicationData = () => {
  const getApplicationDataState = useSelector(
    (state) => state.getApplicationData
  );
  const { getApplicationDetail } = getApplicationDataState;

  return {
    getApplicationDetail,
  };
};
export default useGetApplicationData;
